import { useGetStatuses } from "@/api/console/statuses/useGetStatuses";
import LoadingScreen from "@/components/Loading";
import useProfile from "@/hooks/useProfile";
import useStatuses from "@/hooks/useStatuses";
import { Profile } from "@/schema/Profile";
import { getCookie } from "cookies-next";
import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import AdminSidebar from "./_components/AdminSidebar";

function Layout() {
  const { setProfile } = useProfile();
  const { setStatuses } = useStatuses();
  const navigate = useNavigate();

  const { isLoading } = useGetStatuses({
    onSuccess: (data) => {
      setStatuses(data.data);
    },
  });

  useEffect(() => {
    try {
      const userData = getCookie("user") as string;
      const user = JSON.parse(userData) as Profile;
      setProfile(user);
    } catch (error) {
      navigate("/console/login");
    }
  }, []);

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <div className="flex h-full bg-cool-gray-50">
      <AdminSidebar />
      <div className="grow overflow-auto flex min-h-full flex-col">
        <Outlet />
      </div>
    </div>
  );
}

export default Layout;
